import React from "react";
import MainLayout from "../../../../common/Layout";
import {Image} from "antd";
import useScreenWidth from "../../../../hooks/useScreenWidth";
import Banner from "../../../../components/Career/LeadingBusiness/Banner";
import BannerSmallScreen from "../../../../components/Career/LeadingBusiness/SmallBanner";
import NavbarCareer from "../../../../components/Career/navbar";
import WorkingAtMWL from "../../../../components/Career/LifeAtMacworld/WorkingAtMWL";
import InfortmationSection from "../../../../components/Career/informationSection";
import aboutmeimg from "../../../../assets/careers/Leadershipmwl/LeadingBusiness/Nadia-Ribeiro-6_0-768-768.webp";
import InspiringLeaders from "../../../../components/Career/LeadershipAtMWL/InspiringLeaders";
import impimg from "../../../../assets/careers/Leadershipmwl/LeadingBusiness/imp of leadership.webp";
import Info from "../../../../components/Career/LeadingBusiness/Info";
import nadia from "../../../../assets/careers/Leadershipmwl/LeadingBusiness/nadia.webp";

const aboutMeData = [
  {
    heading: "About Me",
    subHeading1:
      "I was reared in Jordan after being born in Cairo, Egypt, and I have also resided in the US, the UK, and Brazil. In order to oversee air and ocean freight for LATAM, I joined EGL, a company that preceded MAC World, in 2000. I spent three years in Miami because of that, until EGL and TNT merged to establish MAC World. I went away for three years in 2013 after a moment of lunacy! However, I returned and have stayed here ever since; it felt familiar. I am currently the Managing Director for Latin America. Speaking about personal matters, I have two daughters and am married",
    buttonText: "",
    image: aboutmeimg,
    imgFirst: true,
  },
  
];
const importancedata=[{
  heading:"The importance of Leadership:",
  subHeading1:"My primary concentration is on business leadership, yet without team leadership, business leadership is ineffective. Making your team feel important and a part of the vision—building it together and working toward the objectives—is the finest approach to lead. An enabler is a leader. Managing the firm requires effectively balancing the demands of our clients, staff, and customers. This entails figuring out what our customers require and directing our staff accordingly. It is all brought together by the company's goals and the aspirations and vision of its personnel. Then, execution becomes crucial: you have to fulfill.",
  buttonText:"",
  image:impimg,
  imgFirst:false  
}]

export default function LeadingBusiness() {
  const { screenWidth } = useScreenWidth();
  return (
    <MainLayout>
      {screenWidth > 700 ? (
        <Banner
          title="'Leadership Business'"
          desc="Meet XYZ Managing Director"
        />
      ) : (
        <BannerSmallScreen
          heading="Leadership Business"
          text="Meet XYZ Managing Director"
        />
      )}
      <NavbarCareer
        menuItems={[
          { label: "XYZ,Leading Team" },
          { label: "XYZ,Leading Business" },
        ]}
      />
      <WorkingAtMWL
        title="Nadia Rebiero, Leading Business"
        desc="Nadia joined Mac World Logistic in 2000, currently Managing Director for Latin America."
      />
      <InfortmationSection data={aboutMeData} />
      <InspiringLeaders
        title="Why I Choose Mac World Logistic:"
        desc="It was a career move. I started  working for an airline cargo department, made a couple of moves and found I loved logistics, but  wanted a wider regional role. MWL was immediately a good fit for me: I see myself as an entrepreneur, and Mac World Logistic is a company where you are allowed a good degree of autonomy. I am also very aligned with the Mac World  values, especially where I feel that the company is open and supports Diversity and Inclusion."
        bgcolor="white"
        boldtext="There are also great people, fun to work with, and  if you want to grow there are good internal opportunities."
        textalign="justify"
      />
      <InfortmationSection data={importancedata}/>
      <Info title="Leading Business Mac World Logistic:" desc={[{boldtext:"There is very open communication within MAC World: the structure is very flat, flexible and informal. We are very agile." , text:"I have found that some other businesses are sluggish, unyielding, and unbending, with few opportunities to advance. That isn't the case with MacWorld, as the company prioritizes its customers. We talk about clients a lot more than internal processes in our meetings, and you can feel it."},
    {boldtext:"Our support functions – IT and HR - work with the business." , text:"Additionally, there is a strong culture of acknowledgment and celebration. For example, our CEO thanks those who have accomplished a business win and mentions business wins in worldwide announcements."}]}/>
    <div style={{marginTop:"2rem" , width: screenWidth>768?"93%":"100%" , padding:screenWidth>768?"4rem":"1rem" , marginLeft:screenWidth>768 ? "9rem" :"0rem"}} >
      <Image src={nadia} preview={false} style={{width:"100%" , height:"100%" , objectFit:"cover"}}/>
    </div>
    </MainLayout>
  );
}
